<template>
  <div
    class="category-overview-teaser-wrapper"
  >
    <category-overview-teaser
      v-for="(categoryOverviewTeaser, index) in categoryOverviewTeaserTabs"
      :key="index"
      v-bind="categoryOverviewTeaser"
    />
  </div>
</template>

<script>
import CategoryOverviewTeaser from '../categoryOverviewTeaser/categoryOverviewTeaser.vue'

  export default {
    components: {
      CategoryOverviewTeaser
    },
    props: {
      categoryOverviewTeaserTabs: Array,
    }
  };

</script>
